<template>
  <el-container>
    <el-aside width="790px" style="background:#fff9f9;text-align: center;"
      ><el-image
        fit="fill"
        :src="require('@/assets/image/login_left.png')"
      ></el-image
    ></el-aside>
    <el-main style="position:relative;top:-50px">
      <el-card class="box-card login-card">
        <span class="login-title">垚旌供应链管理平台</span>
        <span class="login-tip">Welcome 欢迎登陆</span>
        <el-form
          ref="userRef"
          :model="userForm"
          :rules="rules"
          label-width="80px"
        >
          <el-form-item label="用户名" prop="username">
            <el-input
              v-model.trim="userForm.username"
              placeholder="请输入用户"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input
              v-model.trim="userForm.password"
              type="password"
              placeholder="请输入密码"
              show-password
              @keyup.enter="doLogin"
            ></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="verifyCode" style="display:none">
          <el-col :span="16">
            <el-input
            v-model="userForm.verifyCode"
            placeholder="验证码"
            class="verifyCode"
            @keyup.enter="doLogin"
          ></el-input>
          </el-col>
          <el-col :span="8">
            <img class="verifyCodeImg" :src="verifyCodeUrl" @click="resetVerifyCode" alt="验证码">
          </el-col>
        </el-form-item>
          <el-form-item>
            <el-button type="danger" @click="doLogin" style="width:400px;">登 陆</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </el-main>
  </el-container>
</template>

<script setup>
import { ref } from "vue";
import { ElMessage } from "element-plus";

import { useStore } from "vuex";
import { useRouter } from "vue-router";


const store = useStore();
const router = useRouter();

const userRef = ref();

//验证码
const verifyCodeUrl = ref('/api/user/verifyCode?t='+Math.random());
const resetVerifyCode = () =>{
    verifyCodeUrl.value = '/api/user/verifyCode?t='+Math.random();
}

let userForm = ref({
  username: "",
  password: "",
  verifyCode: '',
});

const resetForm = () => {
  userForm.value = {
    username: "",
    password: "",
    verifyCode:"",
  };
}; 

const doLogin = () => {
  userRef.value.validate((valid) => {
    if (!valid) {
      ElMessage.error("你的数据不对！");
      resetForm()
      resetVerifyCode()
      return;
    }
    store.dispatch("LOGIN", userForm.value).then((res) => {
      if (res.data.code !== 1) {
        ElMessage.error("登录出错，请重新登录！");
        resetForm()
        resetVerifyCode()
        return;
      }
      store.dispatch("GET_ROLE_PERM").then((res) => {
        if (res.data.code !== 1) {
          ElMessage.error("登录出错，请重新登录！");
          resetForm()
          resetVerifyCode()
          return;
        }
        
        store.dispatch("GET_MENU").then((res) => {
          if (res.data.code !== 1) {
            ElMessage.error("登录出错，请重新登录！");
            resetForm()
            resetVerifyCode()
            return;
          }
          router.push({ name: "main" });
        });

      });
      
    });
  });
};

const rules = ref({
  username: [
    {
      required: true,
      message: "请输入用户名",
      trigger: "blur",
    },
    {
      min: 3,
      max: 10,
      message: "用户名长度3到10",
      trigger: "blur",
    },
  ],
  password: [
    {
      required: true,
      message: "请输入密码",
      trigger: "blur",
    },
  ],
  verifyCode: [
    {
      // required: true,
      message: "请输入验证码",
      trigger: "blur",
    },
  ],
});
</script>

<style scoped>
.el-image {
  height: 785px;
}
.login-card {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  width: 480px;
  height: 400px;
  padding: 40px;
}
.login-title {
  width: 459px;
  height: 70px;
  font-size: 40px;
  font-family: AlibabaPuHuiTiB;
  color: #333333;
  line-height: 90px;
  letter-spacing: 1px;
  font-weight: 800;
  display: block;
  text-align: left;
}
.login-tip {
  width: 319px;
  height: 70px;
  font-size: 30px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 90px;
  letter-spacing: 1px;
  display: block;
  text-align: left;
  margin-bottom: 30px;
}
.verifyCodeImg{
    height: 30px;
    vertical-align: middle;
    padding-left: 10px;
}
</style>